import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useModalContext } from "./chunk-UUGUEMMH.mjs";
import { useModalManager } from "./chunk-474T57YK.mjs";

// src/modal-focus.tsx
import { FocusLock } from "@chakra-ui/focus-lock";
import { usePresence } from "framer-motion";
import { useEffect } from "react";
import { RemoveScroll } from "react-remove-scroll";
import { jsx } from "react/jsx-runtime";
function ModalFocusScope(props) {
  var _useModalContext = useModalContext(),
    autoFocus = _useModalContext.autoFocus,
    trapFocus = _useModalContext.trapFocus,
    dialogRef = _useModalContext.dialogRef,
    initialFocusRef = _useModalContext.initialFocusRef,
    blockScrollOnMount = _useModalContext.blockScrollOnMount,
    allowPinchZoom = _useModalContext.allowPinchZoom,
    finalFocusRef = _useModalContext.finalFocusRef,
    returnFocusOnClose = _useModalContext.returnFocusOnClose,
    preserveScrollBarGap = _useModalContext.preserveScrollBarGap,
    lockFocusAcrossFrames = _useModalContext.lockFocusAcrossFrames,
    isOpen = _useModalContext.isOpen;
  var _usePresence = usePresence(),
    _usePresence2 = _slicedToArray(_usePresence, 2),
    isPresent = _usePresence2[0],
    safeToRemove = _usePresence2[1];
  useEffect(function () {
    if (!isPresent && safeToRemove) {
      setTimeout(safeToRemove);
    }
  }, [isPresent, safeToRemove]);
  var index = useModalManager(dialogRef, isOpen);
  return /* @__PURE__ */jsx(FocusLock, {
    autoFocus: autoFocus,
    isDisabled: !trapFocus,
    initialFocusRef: initialFocusRef,
    finalFocusRef: finalFocusRef,
    restoreFocus: returnFocusOnClose,
    contentRef: dialogRef,
    lockFocusAcrossFrames: lockFocusAcrossFrames,
    children: /* @__PURE__ */jsx(RemoveScroll, {
      removeScrollBar: !preserveScrollBarGap,
      allowPinchZoom: allowPinchZoom,
      enabled: index === 1 && blockScrollOnMount,
      forwardProps: true,
      children: props.children
    })
  });
}
export { ModalFocusScope };